import { render, staticRenderFns } from "./ProductReviewsPagination.vue?vue&type=template&id=0a9b4d60&scoped=true&"
import script from "./ProductReviewsPagination.vue?vue&type=script&lang=js&"
export * from "./ProductReviewsPagination.vue?vue&type=script&lang=js&"
import style0 from "./ProductReviewsPagination.vue?vue&type=style&index=0&id=0a9b4d60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b4d60",
  null
  
)

export default component.exports